<template>
  <div class="modal-overlay" v-show="showModal">
    <div class="modal-content">
      <div class="modal-header">提示</div>
      <div class="modal-body">
        <h4>本功能依赖 HBuilderX 2.2.2 及以上版本。若确定已安装，请点继续。</h4>
        <p>没有安装 HBuilderX ？<a href="javascript:void(0);" @click="downloadHbuilderX" target="_blank">点此获取最新版</a></p>
      </div>
      <div class="modal-footer">
        <button class="modal-btn cancel" @click="cancel">放弃</button>
        <button class="modal-btn confirm" @click="confirm">继续</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Modal',
    data() {
      return {
        showModal: false,
      }
    },
    methods: {
      close() {
        this.showModal = false
      },
      show() {
        this.showModal = true
      },
      cancel() {
        this.close()
        this.$emit('cancel')
      },
      confirm() {
        this.close()
        this.$emit('confirm')
      },
      downloadHbuilderX() {
        this.$http.get('https://www.dcloud.io/docs/HBuilder.json?timestamp=' + new Date().getTime())
          .then(function(response) {
            var platform = navigator.platform,
              isWin = platform.indexOf("Win") == 0,
              isMac = platform.indexOf("Mac") == 0;
            if (isWin) {
              location.href = response.data.win[1].path
            } else if (isMac) {
              location.href = response.data.mac[1].path
            } else {
              alert('请在windows或mac环境下下载')
            }
          })
          .catch(function(error) {
            // eslint-disable-next-line
            console.log(error);
          });
        // eslint-disable-next-line
        if (_hmt) {
          // eslint-disable-next-line
          _hmt.push(['_trackEvent', 'HBuilderX', 'download', '下载HBuilderX']);
        }
      }
    }
  }
</script>

<style scoped>
  .modal-overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    text-align: center;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .modal-overlay:after {
    content: "";
    display: inline-block;
    height: 100%;
    width: 0;
    vertical-align: middle;
  }

  .modal-content {
    display: inline-block;
    width: 600px;
    height: auto;
    background-color: white;
    border-radius: 4px;
    vertical-align: middle;
    overflow: hidden;
    text-align: left;
  }

  .modal-header {
    background-color: #f2f2f2;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    padding: 15px;
    color: #000000;
    font-size: 16px;
  }

  .modal-body {
    padding: 15px;
    min-height: 120px;
  }

  .modal-body h4 {
    font-weight: 500;
    font-size: 18px;
    line-height: 1.2;
    margin: 10px 0px;
  }

  .modal-body p {
    line-height: 1.2;
    margin-bottom: 10px;
  }

  .modal-body p a {
    color: #42B983;
  }

  .modal-footer {
    text-align: right;
    padding: 15px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .modal-btn {
    display: inline-block;
    padding: 6px 12px;
    margin-left: 15px;
    border-radius: 20px;
    cursor: pointer;
  }

  .modal-btn:hover {
    opacity: 0.7;
  }

  .modal-btn.cancel {
    border: solid 1px #42B983;
    background-color: white;
    color: #42B983;
  }

  .modal-btn.confirm {
    padding: 6px 20px;
    border: solid 1px #42B983;
    background-color: #42B983;
    color: white;
  }
</style>
